import * as React from 'react';

import PlatformSandbox32 from './PlatformSandbox32';

export const platformSandbox32 = () => <PlatformSandbox32 />;

export default {
    title: 'Icon|Content|PlatformSandbox32',
    component: PlatformSandbox32,
    parameters: {
        notes: "`import PlatformSandbox32 from 'box-ui-elements/es/icon/content/PlatformSandbox32';`",
    },
};
